import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var ScriptTimeoutError = /** @class */ (function (_super) {
    __extends(ScriptTimeoutError, _super);
    function ScriptTimeoutError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    ScriptTimeoutError.classInitializer = null;
    // List of static symbols to link.
    ScriptTimeoutError.classSymbols = null; // [];
    // List of instance symbols to link.
    ScriptTimeoutError.instanceSymbols = null; // [];
    return ScriptTimeoutError;
}(ASError));
export { ScriptTimeoutError };
